import styled, { css } from "styled-components";
import colours from "assets/colours";
import { fonts } from "assets/fontStyles";
import { styledScroll } from "components/shared/layout";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledTextArea = styled.textarea`
  display: flex;
  border-radius: 1.875em;
  background: ${colours.grey4};
  padding: 0em 1.25em;
  border: none;
  width: inherit;
  ${fonts.input}
  padding: 0.75em 1.25em;
  resize: vertical;

  &:focus,
  &:active {
    border: none;
    outline: none;
  }

  &:disabled {
    color: ${colours.grey2};
  }

  ${({ populated }) =>
    populated &&
    css`
      ${fonts.inputPopulated}
    `}

  ${styledScroll};
  ::-webkit-scrollbar-track {
    margin: 15px 0px;
  }
`;

export { Container, StyledTextArea };
